import { render } from "./help-center-questions.vue?vue&type=template&id=31264a5a"
import script from "./help-center-questions.vue?vue&type=script&lang=js"
export * from "./help-center-questions.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__